import { type CVEditingSection, type FullCV } from '@cibli/shared';

import type { CVViewMode } from '../../types';

import EducationSection from './EducationSection';
import ExperienceSection from './ExperienceSection';
import PersonalExperienceSection from './PersonalExperienceSection';
import ProfileSection from './ProfileSection';

interface MainContentProps {
  cv: FullCV;
  mode: CVViewMode;
  onEdit?: (section: CVEditingSection) => void;
}

export default function MainContent({ cv, onEdit }: MainContentProps) {
  return (
    <main className="flex-1 px-[16px] pt-[16px] pb-[16px] flex flex-col [box-decoration-break:clone] [-webkit-box-decoration-break:clone]">
      {/* Summary */}
      <ProfileSection summary={cv.summary} onEdit={onEdit} />

      {/* Expériences professionnelles */}
      <ExperienceSection experiences={cv.experiences} onEdit={onEdit} />

      {/* Expériences personnelles */}
      <PersonalExperienceSection experiences={cv.personalExperiences} onEdit={onEdit} />

      {/* Formations */}
      <EducationSection education={cv.education} onEdit={onEdit} />
    </main>
  );
}
